import { useLora, useLoras } from "@features/loras/use-loras";
import { Button } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { LoraEdit } from "../lora-edit-form";
import { ArrowLeftIcon } from "lucide-react";

export const StepEdit = () => {
  const { t } = useTranslation();
  const { id, site } = useParams();
  const { data: lora } = useLora(id || "");
  const { update } = useLoras();
  const navigate = useNavigate();

  if (!lora) {
    return null;
  }

  return (
    <>
      <div className="mb-4">
        <Button
          variant="ghost"
          onClick={() => navigate(`/${site}/lora/${lora.id}/review`)}
          className="flex items-center gap-2"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          {t("loras.edit.back")}
        </Button>
      </div>
      <LoraEdit
        lora={lora}
        value={lora}
        onChange={async (details) => {
          try {
            await update(lora.id, details);
            navigate(`/${site}/lora/${lora.id}/review`);
          } catch (e) {
            toast.error("Erreur lors de la mise à jour du modèle.");
            console.error(e);
          }
        }}
      />
    </>
  );
};
